import React from 'react';
import { Route, Link, BrowserRouter as Router } from "react-router-dom";
import RateProfile from './RateProfile';
import RateButton from './RateButton';

const IMAGE_BASE = "https://p10-profile-image.s3.amazonaws.com";

export let profileName = '';
export let profileId = '';
export let pImage = '';

const cardStyle = {
  width: "260px",
  background: "#fff",
  borderRadius: "16px",
  overflow: "hidden",
  boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
  paddingBottom: "16px",
  display: "flex",
  flexDirection: "column",
};

const imageWrapperStyle = {
  width: "100%",
  background: "#f3f3f3",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

const imageStyle = {
  width: "100%",
  height: "auto",
  objectFit: "contain",
  display: "block",
};

const contentStyle = {
  padding: "10px 16px",
  textAlign: "center",
};

class Card extends React.Component {
  constructor() {
    super();
    this.state = {
      user: {
        uid: '',
        uname: ''
      }
    }
  }
  
  onSubmitSignIn = () => {
    this.props.onRouteChange('home');
  }
  
  render() {
    let { first_name, last_name, rating, email, image_key, id, rating_count, reported } = this.props;
    
    if (rating == null) {
      rating = 0;
    }
    if (rating_count == null) {
      rating_count = 0;
    }
    
    profileName = first_name;
    profileId = id;
    this.state.user.uname = this.props.first_name;
    pImage = image_key;
    
    const imageURL = reported === 1 
      ? "/images/censorship.jpg" 
      : `${IMAGE_BASE}/${image_key}`;
    
    const displayRating = rating ? Number(rating).toFixed(1) : "0.0";
    const totalRatings = rating_count || 0;
    
    return (
      <div style={cardStyle}>
        {/* IMAGE */}
        <div style={imageWrapperStyle}>
          <img 
            src={imageURL} 
            alt={`${first_name} ${last_name}`} 
            style={imageStyle}
          />
        </div>
        
        {/* TEXT CONTENT */}
        <div style={contentStyle}>
          <h3 style={{ 
            margin: "8px 0", 
            fontSize: "1.2rem", 
            fontWeight: "600",
            color: "#1f2937"
          }}>
            {first_name} {last_name}
          </h3>
          <p style={{ 
            margin: "4px 0", 
            fontSize: "0.95rem",
            color: "#374151"
          }}>
            <strong>p10 Rating:</strong> {displayRating}
          </p>
          <p style={{ 
            margin: "4px 0 12px 0", 
            fontSize: "0.9rem", 
            color: "#6b7280"
          }}>
            <strong>Total Ratings:</strong> {totalRatings}
          </p>
          
          {/* RATE BUTTON */}
          <RateProfile 
            setTest={this.props.setTest} 
            Name={first_name} 
            Id={id}
            ImageKey={image_key}
            onRatingSubmitted={this.props.onRatingSubmitted}
          />
        </div>
      </div>
    );
  }
}

export default Card;